import { Proyecto } from "../proyecto";

export class ConjuntoProyecto {
  idConjuntoProyecto: number = -1;
  idEmpresaAfiliada: number= -1;
  nombre: string="";
  fechaHoraUM:Date;
  idUsuarioUM:number = -1;
  idsProyectos:string ="";
  descripcion:string= "";
  proyectosSeleccionados:Proyecto[];
  proyectosEliminados:Proyecto[];

}
